/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* Kontekst liczb zostaje w tej karcie przeglądarki, nigdy w adresie ani GA4. */
(function (w, d) {
    'use strict';
    var KEY = 'pewniaki:przewodnik-analiz:v1';
    function start() {
        var guide = d.querySelector('[data-przewodnik-analiz]');
        if (!guide) return;
        var game = guide.dataset.gra, en = /^en/.test(d.documentElement.lang), state = guide.querySelector('[data-przewodnik-stan]');
        var rules = {lotto: [6,49], 'lotto-plus': [6,49], 'mini-lotto': [5,42], 'multi-multi': [20,80], eurojackpot: [5,50], kaskada: [12,24]}[game];
        if (!rules) return;
        function valid(data) {
            return data && data.game === game && Number.isFinite(data.time) && Date.now() >= data.time && Date.now() - data.time <= 3600000
                && Array.isArray(data.numbers) && data.numbers.length > 0 && data.numbers.length <= rules[0]
                && (data.numbers.length === rules[0] || game === 'multi-multi' && data.numbers.length <= 10)
                && data.numbers.every(function(n) { return Number.isInteger(n) && n >= 1 && n <= rules[1]; }) && new Set(data.numbers).size === data.numbers.length
                && Array.isArray(data.extra) && (data.extra.length === 0 || game === 'eurojackpot' && data.extra.length === 2 && new Set(data.extra).size === 2 && data.extra.every(function(n) { return Number.isInteger(n) && n >= 1 && n <= 12; }));
        }
        function form() { return d.querySelector('[data-mm-kupon-form]:not([hidden]), [data-zestaw-form]:not([hidden]), [data-f6-form]'); }
        function numbers() {
            var f = form(); if (!f) return null;
            var inputs = f.querySelectorAll('[data-zestaw-liczba]'), values;
            if (inputs.length) values = Array.from(inputs).map(function (p) { return Number(p.value); });
            else { var p = f.querySelector('[data-mm-kupon-liczby], [data-f6-main]'); values = p ? p.value.trim().split(/[\s,;]+/).map(Number) : []; }
            if (!values.length || values.some(function (n) { return !Number.isInteger(n) || n < 1 || n > 80; }) || new Set(values).size !== values.length) return null;
            var extra = f.querySelector('[data-f6-special]');
            var sample = f.querySelector('[data-zestaw-okno], [data-mm-kupon-okno], [data-zakres-okno]');
            var data = { game: game, numbers: values, extra: extra ? extra.value.trim().split(/[\s,;]+/).filter(Boolean).map(Number) : [], sample: sample ? sample.value : null, time: Date.now() };
            return valid(data) ? data : null;
        }
        function fill(data) {
            if (!valid(data)) return;
            if (game === 'multi-multi' && data.numbers.length <= 10 && d.querySelector('[data-mm-tryb-kupon]')) d.querySelector('[data-mm-tryb-kupon]').click();
            var f = form(); if (!f) return;
            var fields = f.querySelectorAll('[data-zestaw-liczba]'), main = f.querySelector('[data-f6-main]');
            if (fields.length === data.numbers.length) fields.forEach(function (p, i) { p.value = data.numbers[i]; p.dispatchEvent(new Event('input', { bubbles: true })); });
            else if (main && data.numbers.length === Number(d.querySelector('[data-f6-podobne]').dataset.typuje)) { main.value = data.numbers.join(' '); var extra = f.querySelector('[data-f6-special]'); if (extra) extra.value = (data.extra || []).join(' '); }
            else if (f.querySelector('[data-mm-kupon-liczby]')) f.querySelector('[data-mm-kupon-liczby]').value = data.numbers.join(' ');
            else return;
            var sample = f.querySelector('[data-zestaw-okno], [data-mm-kupon-okno], [data-zakres-okno]');
            if (sample && Array.from(sample.options).some(function(o) { return o.value === data.sample; })) sample.value = data.sample;
            state.textContent = jst("pages_przewodnik_analiz_js.42062017078c");
        }
        try { fill(JSON.parse(w.sessionStorage.getItem(KEY) || 'null')); } catch (_) {}
        guide.querySelectorAll('[data-przewodnik-wlasne], [data-przewodnik-kontekst]').forEach(function (link) {
            link.addEventListener('click', function (e) {
                var data = numbers();
                if (!data) {
                    if (link.hasAttribute('data-przewodnik-wlasne')) {
                        try { w.sessionStorage.removeItem(KEY); } catch (_) {}
                        if (form()) { e.preventDefault(); state.textContent = jst("pages_przewodnik_analiz_js.f446a05e5b6b"); }
                    }
                    return;
                }
                if (game === 'multi-multi' && data.numbers.length <= 10 && link.dataset.przewodnikWlasne === 'podobne') {
                    e.preventDefault(); state.textContent = jst("pages_przewodnik_analiz_js.a6118dd199b6"); return;
                }
                // Euroliczby nie są częścią obecnego analizatora cech — nie wolno ich zgadywać.
                if (game === 'eurojackpot' && !data.extra.length && link.dataset.przewodnikWlasne === 'podobne') {
                    e.preventDefault(); state.textContent = jst("pages_przewodnik_analiz_js.e9428ee48c55"); return;
                }
                try { w.sessionStorage.setItem(KEY, JSON.stringify(data)); } catch (_) { if(link.hasAttribute('data-przewodnik-wlasne')) e.preventDefault(); state.textContent = jst("pages_przewodnik_analiz_js.36aac02ca723"); }
            });
        });
    }
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})(window, document);
